import React from 'react';
import Head from 'next/head';

import clsx from 'clsx';

import { Icon } from '@/components/icons/Icon';

import { Loader } from '@/_components';

interface ILayoutScreen {
  children: React.ReactNode;
  title: string;
  width?: 'normal' | 'wide';
  isLoading?: boolean;
}

const LayoutScreen = ({ children, title, width = 'normal', isLoading = false }: ILayoutScreen) =>
  isLoading ? (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <Loader />
    </div>
  ) : (
    <div>
      <Head>
        <title>{`${title} - Admin YoungOnes`}</title>
      </Head>
      <section className="min-h-screen bg-accent-lighterGrey">
        <div className="flex h-screen items-center justify-center">
          <div className="mb-8 flex flex-col items-center justify-center gap-10">
            <div className="flex items-center justify-center">
              <a className="h-20 w-32" target="_blank" rel="noreferrer noopener" href="https://youngones.com">
                <Icon icon="youngOnesBlack" />
              </a>
            </div>
            <div className="max-w-full px-6">
              <div
                className={clsx('max-w-full rounded-md border border-gray-100 bg-white p-12', {
                  'w-[30rem]': width === 'normal',
                  'w-[39rem]': width === 'wide',
                })}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );

export default LayoutScreen;
